import { Expression } from './Expression.js';
export class DeriveExpression extends Expression {
    constructor(value) {
        super();
        this.value = value;
    }
    getValue() {
        return this.value;
    }
    evaluate(visitor, localVariables) {
        return this.getValue()
            .evaluate(visitor, localVariables);
    }
}
//# sourceMappingURL=DeriveExpression.js.map